import {Component, Input} from '@angular/core';

/**
 * Generated class for the LubbuLoaderComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'lubbu-loader',
  templateUrl: 'lubbu-loader.html'
})
export class LubbuLoaderComponent {

  @Input() array: any;
  @Input() customMessage: any;

  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/components/lubbu-loader/lubbu-loader.ts